import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    selectAllWorkedTimes,
    selectWorkedTimesEntities, selectWorkedTimesFetched, selectWorkedTimesLatestUpdatedAt,
    workedTimesFeatureKey,
    WorkedTimesState,
} from '../reducers/worked-times.reducer';

const selectState = createFeatureSelector<WorkedTimesState>(workedTimesFeatureKey);
const selectDictionary = createSelector(selectState, selectWorkedTimesEntities);

export const getWorkedTimes = createSelector(selectState, selectAllWorkedTimes);
export const getWorkedTimesFetched = createSelector(selectState, selectWorkedTimesFetched);
export const getWorkedTimesLatestUpdatedAt = createSelector(selectState, selectWorkedTimesLatestUpdatedAt);
export const getWorkedTimesById = createSelector(selectDictionary, (workedTimes: ReturnType<typeof selectDictionary>, Id: number) => Id && workedTimes[Id]);
export interface LoadPlan {
    newCommissionIds: number[];
    knownCommissionIds: number[];
    newWorkDayIds: number[];
    knownWorkDayIds: number[];
    updatedSince: string | null;
}

export const getWorkedTimesByCommissionId = (commissionId: number) =>
    createSelector(
        getWorkedTimes,
        (workedTimes) =>
            workedTimes.filter(
                (w) => w.CommissionId === commissionId
            )
    );
export const selectWorkedTimesByCommissionIds = (commissionIds: number[]) =>
    createSelector(getWorkedTimes, (workedTimes) => workedTimes.filter((w) => commissionIds.includes(w.CommissionId)));
export const selectWorkedTimesLoadPlan = (commissionIds: number[], workDayIds: number[]) =>
    createSelector(selectState, (state: WorkedTimesState): LoadPlan => {
        const newCommissionIds = commissionIds.filter(id => !state.loadedCommissions[id]);
        const knownCommissionIds = commissionIds.filter(id => !!state.loadedCommissions[id]);

        const newWorkDayIds = workDayIds.filter(id => !state.loadedWorkDays[id]);
        const knownWorkDayIds = workDayIds.filter(id => !!state.loadedWorkDays[id]);

        const knownTimestamps = [
            ...knownCommissionIds.map(id => state.loadedCommissions[id]?.lastUpdatedAt).filter(t => !!t),
            ...knownWorkDayIds.map(id => state.loadedWorkDays[id]?.lastUpdatedAt).filter(t => !!t),
        ];

        let updatedSince = null;
        if (knownTimestamps.length) {
            const minTimestamp = Math.min(...knownTimestamps.map(t => new Date(t).getTime()));
            if (!isNaN(minTimestamp)) {
                updatedSince = new Date(minTimestamp).toISOString();
            }
        }

        return { newCommissionIds, knownCommissionIds, newWorkDayIds, knownWorkDayIds, updatedSince };
    });


export const selectAreCommissionsLoaded = (commissionIds: number[]) =>
    createSelector(selectState, (state: WorkedTimesState) => state.fetched || commissionIds.every((id) => !!state.loadedCommissions[id]));

export const selectAreWorkDaysLoaded = (workDayIds: number[]) =>
    createSelector(selectState, (state: WorkedTimesState) => state.fetched || workDayIds.every((id) => !!state.loadedWorkDays[id]));
